import PropTypes from 'prop-types';

import Blog from '../../Cards/Blog';

import { PostsContainer, Posts } from './styles';

const BlogPostTiles = ({ data, currentPage = 1, totalArticle = null }) => {
  const articlesPerPage = 7;
  const lastPage = Math.ceil(totalArticle / articlesPerPage);
  const isLastPage = currentPage === lastPage;
  const lastPageArticleAmount = totalArticle - (lastPage - 1) * articlesPerPage;

  return (
    <PostsContainer>
      <Posts
        lastPageArticleAmount={lastPageArticleAmount}
        isLastPage={isLastPage}
      >
        {data.map(
          (post, index) =>
            index >= currentPage * 7 - 7 &&
            index < currentPage * 7 && (
              <Blog
                data={post}
                wide={index === currentPage * 7 - 7}
                key={post.id}
              />
            ),
        )}
      </Posts>
    </PostsContainer>
  );
};

BlogPostTiles.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentPage: PropTypes.number,
  totalArticle: PropTypes.number,
};

export default BlogPostTiles;
